import api from '@/lib/api'
import { ENDPOINTS } from '@/constants/endpoints'
import type { OrganizationMember, OrganizationInviteRequest } from '@/types/user'

export interface PaginatedMembersResponse {
  count: number
  next: string | null
  previous: string | null
  results: OrganizationMember[]
}

export interface CreateExternalSubscriptionResponse {
  quote_id: string
}

export const organizationsService = {
  createExternalSubscription: async (
    organizationId: string
  ): Promise<CreateExternalSubscriptionResponse> => {
    const response = await api.post<CreateExternalSubscriptionResponse>(
      ENDPOINTS.ORGANIZATIONS.EXTERNAL_SUBSCRIPTION(organizationId),
      {}
    )
    return response.data
  },

  getQuotePdf: async (organizationId: string, quoteId: string): Promise<Blob> => {
    const response = await api.get<Blob>(
      ENDPOINTS.ORGANIZATIONS.QUOTE_PDF(organizationId, quoteId),
      { responseType: 'blob' }
    )
    return response.data
  },

  updateDesiredPricing: async (
    organizationId: string,
    data: { desired_licenses_count: number; desired_billing_details?: string }
  ): Promise<void> => {
    await api.patch(ENDPOINTS.ORGANIZATIONS.UPDATE_DESIRED_PRICING(organizationId), data)
  },

  getMembers: async (
    organizationId: string,
    params?: { limit?: number; offset?: number; ordering?: string; search?: string }
  ): Promise<PaginatedMembersResponse> => {
    const response = await api.get<PaginatedMembersResponse>(
      ENDPOINTS.ORGANIZATION_MEMBERS.LIST(organizationId),
      { params }
    )
    return response.data
  },

  inviteMember: async (
    organizationId: string,
    data: OrganizationInviteRequest
  ): Promise<OrganizationMember> => {
    const response = await api.post<OrganizationMember>(
      ENDPOINTS.ORGANIZATIONS.INVITE(organizationId),
      data
    )
    return response.data
  },

  deactivateMistralSeat: async (organizationId: string, userId: string): Promise<void> => {
    await api.post(ENDPOINTS.ORGANIZATIONS.DEACTIVATE_MISTRAL_SEAT(organizationId, userId))
  },

  removeMember: async (organizationId: string, userId: string): Promise<void> => {
    await api.delete(ENDPOINTS.ORGANIZATIONS.REMOVE_MEMBER(organizationId), {
      data: { user_id: userId },
    })
  },
}
